import { Fragment } from "react";

const pageButton = "grid h-8 min-w-8 cursor-pointer place-items-center rounded-[9px] px-1 text-[13px] transition-colors focus-visible:outline-2 focus-visible:outline-primary";

export default function PaginationControls({ pagination, onChange }) {
  if (!pagination || pagination.total <= pagination.limit) return null;
  const start = pagination.offset + 1;
  const end = Math.min(pagination.offset + pagination.limit, pagination.total);
  const pageCount = Math.ceil(pagination.total / pagination.limit);
  const current = Math.floor(pagination.offset / pagination.limit) + 1;
  const pages = [...new Set([1, current - 1, current, current + 1, pageCount])].filter((page) => page >= 1 && page <= pageCount).sort((left, right) => left - right);
  return (
    <nav className="flex flex-wrap items-center justify-between gap-3 pt-1" aria-label="Pagination">
      <p className="text-[13px] text-muted-foreground">Showing <b className="font-semibold text-foreground">{start}–{end}</b> of {pagination.total}</p>
      <div className="flex items-center gap-1">
        <button
          type="button"
          aria-label="Previous page"
          className={`${pageButton} border border-border text-muted-foreground hover:bg-muted disabled:cursor-not-allowed disabled:opacity-45`}
          disabled={pagination.offset === 0}
          onClick={() => onChange(Math.max(0, pagination.offset - pagination.limit))}
        >‹</button>
        {pages.map((page, index) => (
          <Fragment key={page}>
            {index > 0 && page - pages[index - 1] > 1 && <span className="min-w-7 text-center text-[13px] text-muted-foreground" aria-hidden="true">…</span>}
            <button
              type="button"
              aria-current={page === current ? "page" : undefined}
              className={page === current ? `${pageButton} bg-primary font-semibold text-white` : `${pageButton} text-muted-foreground hover:bg-muted`}
              onClick={() => onChange((page - 1) * pagination.limit)}
            >{page}</button>
          </Fragment>
        ))}
        <button
          type="button"
          aria-label="Next page"
          className={`${pageButton} border border-border text-foreground hover:bg-muted disabled:cursor-not-allowed disabled:opacity-45`}
          disabled={!pagination.has_more}
          onClick={() => onChange(pagination.offset + pagination.limit)}
        >›</button>
      </div>
    </nav>
  );
}
